import { isNil } from 'lodash/fp';

export function convertToGoogleSheetUrl(spreadsheetId: string | null, sheetId: number | null) {
    if (isNil(spreadsheetId) || isNil(sheetId)) {
        return '';
    }

    return `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit#gid=${sheetId}`;
}
